import React from 'react'
import ConditionalRender, {
  Experiment,
  Original
} from '@/components/ConditionalRender'
import IncredibleTileMobileTout from './IncredibleTileMobileTout'
import IncredibleTileMediaCard from './IncredibleTileMediaCard'

export default function IncredibleTileMobile({
  contentFulFieldID
}: {
  contentFulFieldID: 'incredibleTileMobile' | 'incredibleTile'
}) {
  return (
    <ConditionalRender experimentCode="MBL_HP_INCRED_TILE_MEDIA_CARD">
      <Original>
        <IncredibleTileMobileTout incredibleTileContentfulName="incredibleTileMobile" />
      </Original>
      <Experiment>
        <IncredibleTileMediaCard contentFulFieldID={contentFulFieldID} />
      </Experiment>
    </ConditionalRender>
  )
}
